import historiekommentarmuster from './historiekommentarmuster';

export default {
  historiekommentarmuster,
};
